import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getSupplementCategories } from '@api/lookups';
import { ISupplementCategory } from '@interfaces/lookups';

export const handleGetSupplementCategories = createAsyncThunk<
  AxiosResponse<ISupplementCategory[]>,
  void
>('getSupplementCategories', getSupplementCategories);
